import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import { checkPixelCollision } from '../ndgmr.Collision-phaser';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import BackpackLayers from './BackpackLayers';
import gameData from '../gameData';

export default class WorkArea extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     * @param {number} x 
     * @param {number} y 
     */
    constructor(scene, x, y)
    {
        super(scene, x, y);

        this.selectedItem = null;

        this.rotatorShowTimer = 2.3;
        this.selectShowWaiter = this.rotatorShowTimer;

        this.flair = [];
        this.fillType = gameData.menu[1].data.fillTypes[0];
        this.colorInfo = gameData.menu[1].data.colorValues[gameData.menu[1].data.colors[0]];
        this.keyChains = [];

        this.bg = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._game_assets_WorkAreaBg, this).setOrigin(0).setInteractive();
        this.bg.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.hideRotator, this);

        this.backpackLayers = new BackpackLayers(this.scene);
        let bagX = (this.bg.width / 2) - (this.backpackLayers.fullBackpackCanvasImage.width / 2);
        let bagY = this.bg.height - this.backpackLayers.fullBackpackCanvasImage.height - 24;
        this.backpackLayers.x = bagX;
        this.backpackLayers.y = bagY;
        this.add(this.backpackLayers);

        this.displayLayer = this.scene.add.container(this.backpackLayers.x, this.backpackLayers.y).setMask(this.backpackLayers.fullBackpackMask);
        this.add(this.displayLayer);

        this.keychainLayer = this.scene.add.container();
        this.add(this.keychainLayer);

        this.setSize(this.bg.width, this.bg.height);

        this.rotator = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._game_assets_ICON_rotate, this).setVisible(false).setInteractive({ draggable: true, pixelPerfect: true });
        this.rotator.selectorPoint = { x: 0, y: 0 };
        this.rotator.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.startRotate, this);
        this.rotator.on(Phaser.Input.Events.GAMEOBJECT_DRAG, this.doRotate, this);
        this.rotator.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.stopRotate, this);

        this.finalBackpackRenderTexture = new Phaser.GameObjects.RenderTexture(this.scene, 0, 0, this.bg.width, this.bg.height + 200);

        this.once(Phaser.GameObjects.Events.DESTROY, () =>
        {
            this.finalBackpackRenderTexture.destroy();
        });
    }

    startRotate(pointer)
    {
        this.rotator.selectorPoint = ABCyaPhaser.GameObjects.getScreenPosition(this.rotator);
        let angle = Math.atan2(pointer.y - this.rotator.selectorPoint.y, pointer.x - this.rotator.selectorPoint.x);
        angle = angle * (180 / Math.PI);
        this.rotator.startAngle = angle - this.selectedItem.angle;
    }

    doRotate(pointer)
    {
        let angle = Math.atan2(pointer.y - this.rotator.selectorPoint.y, pointer.x - this.rotator.selectorPoint.x);
        angle = angle * (180 / Math.PI);
        this.selectedItem.angle = angle - this.rotator.startAngle;
        this.rotator.angle = this.selectedItem.angle;
        this.selectShowWaiter = this.rotatorShowTimer;
    }

    stopRotate()
    {

    }

    checkBackpackCollision(item)
    {
        let hit = false;
        let col = checkPixelCollision(item, this.backpackLayers.fullBackpackCanvasImage, 0, false, true);
        if (col) hit = true;

        return hit;
    }

    /**
     * 
     * @param {Phaser.GameObjects.Image} item 
     */
    addDragItem(item)
    {
        const screenPos = ABCyaPhaser.GameObjects.getScreenPosition(item);
        let pos = this.displayLayer.getLocalPoint(screenPos.x, screenPos.y);
        item.setOrigin(0.5);
        item.x = pos.x + item.displayOriginX;
        item.y = pos.y + item.displayOriginY;
        this.displayLayer.add(item);

        this.flair.push(item);
        item.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, pointer => this.startDrag(pointer, item), this);

        this.selectedItem = item;
        this.showRotator(this.selectedItem);
    }

    startDrag(pointer, sender)
    {
        this.scene.input.once(Phaser.Input.Events.POINTER_UP, pointer => this.stopDrag(pointer, sender));
        sender.on(Phaser.Input.Events.GAMEOBJECT_DRAG, pointer => this.doDrag(pointer, sender), this);
        sender.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, pointer => this.stopDrag(pointer, sender), this);
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._patches, this.scene);
        let item = sender;
        let opos = ABCyaPhaser.GameObjects.getScreenPosition(item);
        let pos = this.getLocalPoint(opos.x, opos.y);
        item.x = pos.x;
        item.y = pos.y;
        if (item.parentContainer) item.parentContainer.remove(item);
        this.add(item);
        item.dragOffsetX = pos.x - pointer.x;
        item.dragOffsetY = pos.y - pointer.y;

        this.selectedItem = item;

        this.rotator.setVisible(false);
    }

    doDrag(pointer, sender)
    {
        let item = sender;
        let newX = pointer.x + item.dragOffsetX;
        let newY = pointer.y + item.dragOffsetY;
        item.x = newX;
        item.y = newY;
    }

    stopDrag(pointer, sender)
    {
        this.scene.input.off(Phaser.Input.Events.POINTER_UP);
        sender.off(Phaser.Input.Events.GAMEOBJECT_DRAG);
        sender.off(Phaser.Input.Events.GAMEOBJECT_POINTER_UP);
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._patches, this.scene);
        let item = sender;
        let newX = pointer.x + item.dragOffsetX;
        let newY = pointer.y + item.dragOffsetY;
        item.x = newX;
        item.y = newY;

        let pos = ABCyaPhaser.GameObjects.getScreenPosition(item);
        let newPos = this.displayLayer.getLocalPoint(pos.x, pos.y);
        item.x = newPos.x;
        item.y = newPos.y;
        if (item.parentContainer) item.parentContainer.remove(item);
        this.displayLayer.add(item);

        if (!this.checkBackpackCollision(item))
        {
            let index = this.flair.indexOf(item);
            this.flair.splice(index, 1);
            item.destroy();
        }
        else
        {
            this.showRotator(this.selectedItem);
        }
    }

    showRotator(item)
    {
        this.rotator.angle = 0;
        this.rotator.x = item.x + this.displayLayer.x;
        this.rotator.y = item.y + this.displayLayer.y;
        this.rotator.setVisible(true);
        this.selectShowWaiter = this.rotatorShowTimer;
    }

    hideRotator()
    {
        this.selectShowWaiter = -1;
        this.rotator.setVisible(false);
    }

    addKeychainItem(item)
    {
        let pos = this.keychainLayer.getLocalPoint(item.x, item.y);
        item.x = pos.x;
        item.y = pos.y;
        this.keychainLayer.add(item);
        item.delegate = this;
        this.keyChains.push(item);
    }

    removeKeychainItem(item)
    {
        let index = this.keyChains.indexOf(item);
        this.keyChains.splice(index, 1);
        this.keychainLayer.remove(item, true);
    }

    changeMainItem(index)
    {
        for (let i = 0; i < this.keyChains.length; i++)
        {
            let item = this.keyChains[i];
            item.handle.removeAllListeners();
            this.keychainLayer.remove(item, true);
        }
        this.keyChains = [];

        this.flair.forEach(f => 
        {
            if (f.parentContainer) f.parentContainer.remove(f);
            f.destroy();
        });
        this.flair = [];
        this.backpackLayers.setFreshBag(index);
        let bagX = (this.bg.width / 2) - (this.backpackLayers.fullBackpackCanvasImage.width / 2);
        let bagY = this.bg.height - this.backpackLayers.fullBackpackCanvasImage.height - 24;
        this.backpackLayers.x = bagX;
        this.backpackLayers.y = bagY;
        this.displayLayer.x = this.backpackLayers.x;
        this.displayLayer.y = this.backpackLayers.y;
    }

    drawPattern(index, value)
    {
        this.backpackLayers.drawPattern(index, value);
    }

    saveUserBackpack()
    {
        let c = this.scene.textures.createCanvas("displaylayercanvas", this.bg.width, this.bg.height);

        // create a temporary image to show the display layer
        let displayLayerTemp = this.scene.add.image(0, 0, "displaylayercanvas").setOrigin(0).setVisible(false);
        this.displayLayer.iterate(go =>
        {
            const bounds = go.getBounds();
            const centerLocalPos = this.getLocalPoint(bounds.centerX, bounds.centerY);
            c.context.translate(centerLocalPos.x, centerLocalPos.y);
            c.context.rotate(go.rotation);
            c.context.drawImage(go.frame.source.image, go.frame.data.drawImage.x, go.frame.data.drawImage.y, go.frame.data.drawImage.width, go.frame.data.drawImage.height, -go.width/2, -go.height/2, go.width, go.height);
            c.context.rotate(-go.rotation);
            c.context.translate(-centerLocalPos.x, -centerLocalPos.y);
        });

        c.context.globalCompositeOperation = "destination-in";
        c.context.drawImage(this.backpackLayers.fullBackpackMaskGraphic.frame.source.image, this.backpackLayers.fullBackpackMaskGraphic.frame.data.drawImage.x, this.backpackLayers.fullBackpackMaskGraphic.frame.data.drawImage.y, this.backpackLayers.fullBackpackMaskGraphic.frame.data.drawImage.width, this.backpackLayers.fullBackpackMaskGraphic.frame.data.drawImage.height, this.backpackLayers.x, this.backpackLayers.y, this.backpackLayers.fullBackpackMaskGraphic.frame.data.drawImage.width, this.backpackLayers.fullBackpackMaskGraphic.frame.data.drawImage.height);
        c.context.globalCompositeOperation = "source-over";

        c.refresh();

        this.finalBackpackRenderTexture.draw([this.backpackLayers, displayLayerTemp, this.keychainLayer]);
        this.finalBackpackRenderTexture.saveTexture("backpack");

        this.scene.textures.remove(c);
        displayLayerTemp.destroy();
    }

    setFillType(value)
    {
        this.fillType = value;
        this.backpackLayers.fillColor(this.colorInfo, this.fillType);
    }

    colorBackpack(colorInfo)
    {
        this.colorInfo = colorInfo;
        this.backpackLayers.fillColor(this.colorInfo, this.fillType);
    }

    preUpdate(time, dt)
    {
        if (this.selectShowWaiter < 0)
        {
            this.hideRotator();
        }
        else
        {
            this.selectShowWaiter -= dt / 1000;
        }

        let len = this.keyChains.length;
        for (let i = 0; i < len; i++)
        {
            this.keyChains[i].tick(dt / 1000);
        }
    }
}